(function (angular) {
    "use strict";

    var serviceRequestService = angular.module('service.ChangePasswordRequest', []);

    serviceRequestService.factory('changePasswordRequestService', ['halClient', 'appSettings', function (halClient, appSettings) {

        var changePasswordUrl = appSettings.apiBaseUri + "/changePasswordRequest";

        return {
            makeRequest: function (userId,username) {
                return halClient.$post(changePasswordUrl, {'Content-Type': 'application/json'}, {'userId': userId,'username': username});
            }
        }
    }]);
})(angular);